<template>
    <el-popover
        placement="bottom-start"
        :visible-arrow="false"
        :disabled="contactInfos.length < 2"
        popper-class="related-contacts-popper"
        trigger="click"
    >
        <template slot="reference">
            <div v-if="contactInfos.length">
                <span class="link-label" @click.stop="handleClickPersonnelDetail(contactInfos[0])">{{
                    contactInfos.length ? contactInfos[0].name : ""
                }}</span>
                <span class="link-label related-count-lable" v-if="contactInfos.length > 1"
                    >，+{{ contactInfos.length - 1 }}</span
                >
            </div>
        </template>
        <div class="related-contacts-content">
            <p class="title">关联联系人</p>
            <ul>
                <li v-for="item in contactInfos" :key="item.id">
                    <span class="link-label ellipsis" @click="handleClickPersonnelDetail(item)">{{ item.name }}</span>
                    <span>{{ item.phone ? (isPhoneEncryption ? phoneEncryption(item.phone) : item.phone) : "" }}</span>
                </li>
            </ul>
        </div>
        <PersonnelDetail
            :personnelDetailVisible.sync="personnelDetailVisible"
            :contactId="contactId"
            :isPhoneEncryption="isPhoneEncryption"
            v-if="personnelDetailVisible"
        />
    </el-popover>
</template>
<script>
import { phoneEncryption } from "@/utils";
import PersonnelDetail from "./personnel_detail.vue";
export default {
    name: "RelatedContacts",
    components: { PersonnelDetail },
    props: {
        contactInfos: {
            type: Array,
            default: [],
        },
        isPhoneEncryption: {
            type: Boolean,
            default: true,
        }, // 手机号是否加密
    },
    data() {
        return {
            currentUserInfo: {},
            personnelDetailVisible: false,
            contactId: "",
            phoneEncryption,
        };
    },
    methods: {
        handleClickPersonnelDetail({ id }) {
            this.contactId = Number(id);
            this.personnelDetailVisible = true;
        },
    },
};
</script>
<style lang="scss">
.related-count-lable {
    margin-left: 3px;
}
.related-contacts-popper {
    margin-top: 2px !important;
    min-width: 216px;
    max-width: 286px;
    border-radius: 6px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(232, 232, 232, 1);
    box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.08);
    padding: 16px 0 8px;

    .related-contacts-content {
        .title {
            padding: 0 12px;
            font-size: 14px;
            font-weight: 700;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(51, 51, 51, 1);
            margin-bottom: 8px;
        }

        ul {
            padding: 0 12px;
            max-height: 300px;
            overflow-y: scroll;
            li {
                padding: 8px 0;
                display: flex;
                justify-content: space-between;
                gap: 8px;
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(102, 102, 102, 1);
                &:not(:last-child) {
                    border-bottom: 1px solid rgba(232, 232, 232, 1);
                }

                .link-label {
                    color: rgba(25, 144, 255, 1);
                    flex: 1;
                }
            }
        }
    }
}
</style>
